var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSmallArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.50028C6.99757 3.23723 6.89158 2.98573 6.705 2.80028L4.56 0.650279C4.46632 0.557154 4.33959 0.504883 4.2075 0.504883C4.07541 0.504883 3.94868 0.557154 3.855 0.650279C3.80814 0.696761 3.77094 0.752061 3.74556 0.812991C3.72017 0.873921 3.7071 0.939273 3.7071 1.00528C3.7071 1.07129 3.72017 1.13664 3.74556 1.19757C3.77094 1.2585 3.80814 1.3138 3.855 1.36028L5.5 3.00028H0.5C0.367392 3.00028 0.240215 3.05296 0.146447 3.14673C0.0526785 3.24049 0 3.36767 0 3.50028C0 3.63289 0.0526785 3.76006 0.146447 3.85383C0.240215 3.9476 0.367392 4.00028 0.5 4.00028H5.5L3.855 5.64528C3.76085 5.73877 3.70769 5.86583 3.70722 5.99851C3.70675 6.13119 3.75901 6.25863 3.8525 6.35278C3.94599 6.44693 4.07305 6.50009 4.20573 6.50056C4.33842 6.50103 4.46585 6.44877 4.56 6.35528L6.705 4.20528C6.8928 4.0186 6.99889 3.76507 7 3.50028Z",
    fill: "#778083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSmallArrow);
export default __webpack_public_path__ + "static/media/right-small-arrow.8efe140492a206f087115a90e3694445.svg";
export { ForwardRef as ReactComponent };